var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopTabletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Desktop",
    d: "M316.72,406.04l-143.9.08c-3.26,0-6.73-1.83-6.72-5.35l.07-19.7c.01-3.23,3.35-5.07,6.16-5.07l24.83.02.68-3.89,2.82-14.14-123.91-.04c-10.2-1.28-17.63-8.75-18.98-18.9l.02-227.01c1.51-9.71,8.58-16.8,18.22-18.6h335.98c10.07,1.6,17.71,9.42,18.56,19.59l-.02,226.33c-1.62,10.02-8.88,17.29-18.98,18.59l-123.93.04,3.48,18.03h25.23c3.02.14,5.93,2.45,5.92,5.64l-.06,19.19c0,2.35-2.55,5.18-5.46,5.19ZM418.47,114.18c0-4.62-3.69-7.82-8.03-8.69H78.52c-4.5.33-7.54,3.34-8.72,7.67v196.71s348.7-.03,348.7-.03l-.04-195.66ZM275.43,358l-62.61.02-3.36,18.03,69.41-.07-3.44-17.99ZM178,388.07v6.02s132.29-.01,132.29-.01v-6.02s-132.29.01-132.29.01ZM418.52,337.7l-.06-15.77H69.84s-.05,15.88-.05,15.88c.5,3.6,3.64,8.12,7.96,8.12l332.88.04c4.46-.83,7.4-4.11,7.89-8.28ZM256.17,333.42c-.29-3.07-2.72-5.51-6-5.51h-12.06c-2.42,0-4.64,1.62-5.44,3.45-1.03,2.36-.71,4.8.97,6.79.86,1.02,2.67,1.76,4.16,1.75l13.22-.1c3.47-.03,5.42-3.52,5.15-6.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M493.76,240.45c5.35.95,10.24,5.51,10.24,10.82l.03,155.95c0,5.73-4.67,10.58-10.27,11.34h-126.62c-5.24-.87-10.08-5.47-10.08-10.98v-156.13c.01-5.76,4.97-10.04,10.44-10.99h126.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M483.07,252.87c4.45.81,8.51,4.74,8.51,9.31l.02,134.19c0,4.93-3.88,9.1-8.54,9.76h-105.21c-4.35-.75-8.38-4.7-8.38-9.45v-134.34c0-4.95,4.13-8.64,8.68-9.46h104.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M485.75,392.45v-125.78c0-3.4-2.69-6.84-6.3-6.84h-97.67c-3.45,0-6.45,3.16-6.45,6.56v126.35c0,3.21,3.04,6.46,6.55,6.47l96.85.02c1.97,0,3.62-.59,4.98-1.95s2.04-2.9,2.04-4.82Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.54,
    cy: 392.74,
    rx: 4.71,
    ry: 4.69
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.54,
    cy: 266.28,
    rx: 2.76,
    ry: 2.74
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M479.27,386.25h-97.43c-.72-.14-1.38-.58-1.38-1.39v-110.8c0-.87.84-1.3,1.62-1.3h97.2c.61,0,1.35.54,1.35,1.17v111.07c-.17.7-.56,1.08-1.35,1.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 385.08,
    y: 278.37,
    width: 90.92,
    height: 101.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopTabletIcon);
export default __webpack_public_path__ + "static/media/desktopTabletIcon.ba70d7ac06f691033c0da75f2c92b7fb.svg";
export { ForwardRef as ReactComponent };